import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-block;

  & > img {
    vertical-align: middle;
  }
`;
